import { computed, inject, Injectable, signal } from '@angular/core'
import { ENVIRONMENT, Environment } from '@mybitzer/core/environment.token'

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private environment = inject(ENVIRONMENT)

  readonly config = signal<Environment | null>(null)

  // Individual signals for commonly accessed values
  readonly isChina = computed(() => this.config()?.isChina ?? this.environment.isChina)
  readonly isBackoffice = computed(() => this.config()?.backoffice ?? this.environment.backoffice)
  readonly production = computed(() => this.config()?.production ?? this.environment.production)
  readonly embedded = computed(() => this.config()?.embedded ?? this.environment.embedded)
  readonly cnEnergyView = computed(() => this.config()?.cnEnergyView ?? this.environment.cnEnergyView)
  readonly googleAnalyticsId = computed(() => this.config()?.googleAnalyticsId ?? this.environment.googleAnalyticsId)
  readonly keycloak = computed(() => this.config()?.keycloak ?? this.environment.keycloak)
  readonly featureFlags = computed(() => this.config()?.featureFlags ?? this.environment.featureFlags)
  readonly tabOrder = computed(() => this.config()?.tabOrder ?? this.environment.tabOrder)
  readonly packageExpiryWarningDays = computed(() => this.config()?.packageExpiryWarningDays ?? this.environment.packageExpiryWarningDays)

  async load(cfg: Environment | null = null): Promise<void> {
    this.config.set(cfg ?? this.environment)
  }

  get<T>(key: string): T {
    const configValue = this.config()
    if (!configValue) {
      throw new Error('Config not loaded yet')
    }
    return configValue[key as keyof Environment] as T
  }

  isFeatureEnabled(featureName: string): boolean {
    return this.featureFlags()?.[featureName] ?? false
  }
}
